import { observer } from "mobx-react-lite";
import './FabricCard.scss'
import { Badge } from "./Badge";
import BadgeIcon from "./BadgeIcon";
import PetTooltip from "./PetTooltip";
import { Button } from "./Button";
import { store } from "../stores/Store";
import { publicUrl } from "../utils/url";
import { SquareBadge } from "./SquareBadge";
import { ColorBox } from "./ColorBox";
import { image } from "motion/react-client";
import { prepareDataAttributesObject } from "../utils/HtmlUtils";
import Img from "./Img";
import CornerCheck from "../icons/CornerCheck";
import { _t } from "../utils/Lang";
import { formatCurrency } from "../utils/Currency";


type Props = {
    onClick: () => void,
    data?: Object,
    name?: string,
    documentationLink?: string,
    price?: number,
    checked?: boolean,
    bestseller?: boolean,
    attributes?: Array<{ name: string, value: string }>,
    properties?: Array<{ name: string, value: string, iconName?: string, tooltip?: string }>,
    className?: string,
    imageUrl?: string,
    hideSwatch?: boolean
}

const FabricCard: React.FC<Props> = observer(({
    onClick,
    name = 'Jasmine',
    badge = '',
    documentationLink = null,
    price = 222,
    data = null,
    checked = false,
    bestseller = false,
    attributes = [],
    properties = [],
    className = '',
    imageUrl = publicUrl('/assets/fabric.png'),
    videoUrl = null,
    hideSwatch = false
}) => {
    var classes = ['FabricCard', className];
    if (checked) {
        classes.push('FabricCard--checked');
    }

    return (
        <div
            {...prepareDataAttributesObject(data)}
            onClick={(e) => {
                if (e.target.closest('.FabricCard__button') === null && e.target.closest('.badges') === null && typeof onClick === 'function') {
                    onClick();
                }
            }}
            className={classes.join(' ')}

        >
            <div className="FabricCard__body">
                <div className="FabricCard__photo">
                    {/* <img src={imageUrl} alt="" style={{ background: '#eee' }} /> */}
                    <Img src={imageUrl} alt="" style={{ background: '#eee', zIndex: 0 }} />
                    <div className="badges" style={{ zIndex: 1 }}>


                        {/* <BadgeIcon name="drop" />
                        <PetTooltip iconName={'pet'} title={'Pet friendly'} text={'Minim dolor pariatur ullamco reprehenderit.'}>
                            <BadgeIcon name="pet" />
                        </PetTooltip> */}
                        {properties.map((property, index) => {
                            return (
                                <PetTooltip key={index} iconName={property.iconName} title={property.value} text={property.tooltip}>
                                    <BadgeIcon name={property.iconName} />
                                </PetTooltip>
                            )
                        })}
                    </div>

                    {badge && <div className="FabricCard__bestseller">{badge}</div>}

                    {
                        hideSwatch === false ? (
                            <Button
                                className="FabricCard__button btn-xs white"
                                onClick={() => {
                                    store.openVideoPopup({
                                        videoUrl
                                    });
                                }}
                            >
                                {_t('view_sample')}
                                <svg className="FabricCard__button-icon icon-right ms-1 btn-sm white" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.5 9.6891L9.68275 7.00635L5.5 4.3236V9.6891ZM7.00244 13.7563C6.06906 13.7563 5.1915 13.5792 4.36975 13.225C3.54813 12.8707 2.83338 12.39 2.2255 11.7827C1.61763 11.1755 1.13644 10.4613 0.781937 9.64035C0.427312 8.81947 0.25 7.94229 0.25 7.00879C0.25 6.07541 0.427125 5.19785 0.781375 4.3761C1.13562 3.55447 1.61637 2.83972 2.22362 2.23185C2.83087 1.62397 3.545 1.14279 4.366 0.788285C5.18687 0.43366 6.06406 0.256348 6.99756 0.256348C7.93094 0.256348 8.8085 0.433473 9.63025 0.787723C10.4519 1.14197 11.1666 1.62272 11.7745 2.22997C12.3824 2.83722 12.8636 3.55135 13.2181 4.37235C13.5727 5.19322 13.75 6.07041 13.75 7.00391C13.75 7.93729 13.5729 8.81485 13.2186 9.6366C12.8644 10.4582 12.3836 11.173 11.7764 11.7808C11.1691 12.3887 10.455 12.8699 9.634 13.2244C8.81312 13.579 7.93594 13.7563 7.00244 13.7563ZM7 13.0063C8.675 13.0063 10.0938 12.4251 11.2563 11.2626C12.4188 10.1001 13 8.68135 13 7.00635C13 5.33135 12.4188 3.9126 11.2563 2.7501C10.0938 1.5876 8.675 1.00635 7 1.00635C5.325 1.00635 3.90625 1.5876 2.74375 2.7501C1.58125 3.9126 1 5.33135 1 7.00635C1 8.68135 1.58125 10.1001 2.74375 11.2626C3.90625 12.4251 5.325 13.0063 7 13.0063Z" fill="#1F1F1F" />
                                </svg>

                            </Button>

                        ) : null
                    }

                </div>
                <div className="FabricCard__text">
                    <div className="FabricCard__title">{name}</div>
                    <Badge style={{
                        position: 'absolute',
                        top: 0,
                        right: 0
                    }}>{formatCurrency(price, { showSign: true, decimal: 0 })}</Badge>
                    {
                        attributes.length > 0 ? <ul>
                            {
                                attributes.slice(0, 3).map((item, index) => {
                                    return <li key={index}>
                                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.041 8.66709L9.30517 4.40292L8.83333 3.93109L5.041 7.72342L3.141 5.82342L2.66917 6.29525L5.041 8.66709ZM6.00217 12.0619C5.1725 12.0619 4.39244 11.9045 3.662 11.5896C2.93167 11.2747 2.29633 10.8474 1.756 10.3076C1.21567 9.76781 0.787944 9.13303 0.472833 8.40325C0.157611 7.67359 0 6.89387 0 6.06409C0 5.23442 0.157444 4.45436 0.472333 3.72392C0.787222 2.99359 1.21456 2.35825 1.75433 1.81792C2.29411 1.27759 2.92889 0.849865 3.65867 0.534753C4.38833 0.219531 5.16806 0.0619202 5.99783 0.0619202C6.8275 0.0619202 7.60756 0.219365 8.338 0.534254C9.06833 0.849143 9.70367 1.27648 10.244 1.81625C10.7843 2.35603 11.2121 2.99081 11.5272 3.72059C11.8424 4.45025 12 5.22998 12 6.05975C12 6.88942 11.8426 7.66948 11.5277 8.39992C11.2128 9.13025 10.7854 9.76559 10.2457 10.3059C9.70589 10.8463 9.07111 11.274 8.34133 11.5891C7.61167 11.9043 6.83194 12.0619 6.00217 12.0619ZM6 11.3953C7.48889 11.3953 8.75 10.8786 9.78333 9.84525C10.8167 8.81192 11.3333 7.55081 11.3333 6.06192C11.3333 4.57303 10.8167 3.31192 9.78333 2.27859C8.75 1.24525 7.48889 0.728587 6 0.728587C4.51111 0.728587 3.25 1.24525 2.21667 2.27859C1.18333 3.31192 0.666667 4.57303 0.666667 6.06192C0.666667 7.55081 1.18333 8.81192 2.21667 9.84525C3.25 10.8786 4.51111 11.3953 6 11.3953Z" fill="#AD864D" />
                                        </svg>

                                        {item}
                                    </li>
                                })
                            }
                        </ul> : null
                    }
                    {
                        checked ? (
                            <SquareBadge>
                                <ColorBox style={{ background: `url(${store.selectedFabric?.imageUrl})` }} />
                                <span>{_t('color')}: {store.selectedFabric?.name || '-'}</span>
                                <span className="ms-auto t-underline">{_t('change')}</span>
                            </SquareBadge>

                        ) : null
                    }

                    {
                        documentationLink ? (
                            <a href="#" onClick={e => {
                                e.preventDefault();
                                store.openTechnicalCardPopup();
                            }} target="_blank" rel="noopener noreferrer" className="FabricCard__link">
                                {_t('fabric_tech_sheet')}
                            </a>
                        ) : null
                    }

                </div>

            </div>
            {checked && <CornerCheck className="ColorCard__check" />}
        </div>
    )
});

FabricCard.displayName = 'FabricCard'
export default FabricCard